import React from "react"
import {Card, CardBody, CardTitle, Col, Table} from "reactstrap";

export default class Loader extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.title !== nextProps.title)
      return true;
    else if (this.props.children !== nextProps.children)
      return true;
    return false;
  }

  render() {
    return (
      <Col xs={this.props.xs || 4} className='px-2 py-2'>
        <Card>
          <CardBody className='px-2 py-2'>
            <CardTitle className="text-center">{this.props.title}</CardTitle>
            {this.props.children}
          </CardBody>
        </Card>
      </Col>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/InfoBox.js